
import Vue from "vue";
import Crm from "@/models/crm/crm";
import CrmStatus from "@/models/crm/crm-status";
import { CrmService } from "@/services/crm-service";

export default Vue.extend({
	data(){
		return{
			statuses: [] as CrmStatus[],
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
	},
	computed: {
		statusList(): any[]{
			return this.statuses.map(s => {
				return {
					text: s.Name,
					value: s.ID
				};
			});
		},
	},
	methods: {

	},
	created(){
		this.statuses = CrmService.statuses;
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
	